import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetAppReservationUsers(club) {

  var url = "/reservation/get_all_users/" + club;
  
  return FetchGetDataWithAuthNEW(url);
}

